import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const fetchOtherInfos = () =>
  axios
    .get(Routes.search_other_infos_path({ format: 'json' }))
    .then(({ data }) => data);

export const useQueryOtherInfos = ({
  defaultData = () => AlumniConnect?.other_infos,
  fallbackData = () => [],
  getter = (data) => data,
} = {}) => {
  const { data, isSuccess } = useQueryOnce({
    queryKey: ['otherInfos'],
    queryFn: fetchOtherInfos,
  });

  return (isSuccess ? getter(data) : fallbackData()) || defaultData();
};
